import { render, staticRenderFns } from "./AreaList.vue?vue&type=template&id=48e7d398&scoped=true&"
import script from "./AreaList.vue?vue&type=script&lang=ts&"
export * from "./AreaList.vue?vue&type=script&lang=ts&"
import style0 from "./AreaList.vue?vue&type=style&index=0&id=48e7d398&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7d398",
  null
  
)

export default component.exports